import React          from 'react';
import classNames     from 'classnames';
import * as PropTypes from 'prop-types';

const RangeSliderHandle = props => {
  const {
          fromTo,
          showLabel,
          labelPos,
          label,
          showCurrency,
          currencyPos,
          currency,
          type,
          left,
          onMouseDown,
          onTouchStart,
          zIndex,
        } = props;
  return (
    <span
      className={classNames('handle', type)}
      style={{
        left:   `${left}%`,
        zIndex: zIndex === type ? 2 : 1,
      }}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
    >
    {true === showLabel && (
      <span className={classNames('label', labelPos)}>
        {true === fromTo && (type === 'min' ? `from ` : `to `)}
        {true === showCurrency && currencyPos === 'left' && currency}
        {label}
        {true === showCurrency && currencyPos === 'right' && currency}
      </span>
    )}
  </span>
  );
};

RangeSliderHandle.defaultProps = {
  fromTo:       false,
  showLabel:    true,
  labelPos:     'bottom',
  showCurrency: false,
  currencyPos:  'right',
  currency:     'BYN',
};

RangeSliderHandle.propTypes = {
  fromTo:       PropTypes.bool,
  showLabel:    PropTypes.bool,
  labelPos:     PropTypes.string,
  label:        PropTypes.number,
  showCurrency: PropTypes.bool,
  currencyPos:  PropTypes.string,
  currency:     PropTypes.string,
  type:         PropTypes.string.isRequired,
};

export default RangeSliderHandle;